function initVelqinoVariants(scope=document){
scope.querySelectorAll('[data-variant-select]').forEach(select=>{
if(select.dataset.initialized)return;
select.dataset.initialized='true';
const root=select.closest('.product-purchase'),picker=select.closest('[data-variant-picker]'),button=root.querySelector('[data-add-button]');
const update=()=>{
const option=select.selectedOptions[0];
if(!option){button.disabled=true;return;}
const available=option.dataset.available==='true';
button.disabled=!available;button.textContent=available?'In den Warenkorb':'Ausverkauft';
root.querySelector('[data-availability]').textContent=available?'Verfügbar':'Aktuell nicht verfügbar';
root.querySelector('[data-price]').textContent=new Intl.NumberFormat(document.documentElement.lang||'de-DE',{style:'currency',currency:select.dataset.currency||'EUR'}).format(Number(option.dataset.price)/100);
const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState(null,'',url);
};
select.addEventListener('change',update);
if(!picker)return;
const fields=[...picker.querySelectorAll('[data-product-option]')],variants=JSON.parse(picker.querySelector('[data-variant-data]').textContent);
const current=variants.find(v=>String(v.id)===select.value);
if(current)fields.forEach((field,index)=>field.value=current.options[index]);
const choices=[...picker.querySelectorAll('[data-option-choice]')];
const syncOptions=()=>{
fields.forEach((field,index)=>[...field.options].forEach(option=>{
option.disabled=!variants.some(v=>v.options[index]===option.value&&fields.every((other,j)=>j===index||v.options[j]===other.value));
}));
choices.forEach(choice=>{const field=fields[Number(choice.dataset.optionChoice)];choice.checked=field.value===choice.value;choice.disabled=[...field.options].find(o=>o.value===choice.value)?.disabled??true;});
};
choices.forEach(choice=>choice.addEventListener('change',()=>{if(!choice.checked)return;const field=fields[Number(choice.dataset.optionChoice)];field.value=choice.value;field.dispatchEvent(new Event('change',{bubbles:true}));}));
fields.forEach(field=>field.addEventListener('change',()=>{
const match=variants.find(v=>fields.every((f,index)=>f.value===v.options[index]));
if(!match){button.disabled=true;select.value='';return;}
select.value=String(match.id);select.dispatchEvent(new Event('change',{bubbles:true}));syncOptions();
}));
picker.querySelector('[data-variant-fallback]').hidden=true;
picker.querySelector('[data-option-fields]').hidden=false;
syncOptions();
});
}
initVelqinoVariants();
document.addEventListener('shopify:section:load',event=>initVelqinoVariants(event.target));
document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.header-actions details[open]').forEach(el=>{el.removeAttribute('open');el.querySelector('summary').focus()})});
